/*
 * Created by: cparaschiv
 * Date: 11.02.2014, 10:23
 */


var baseMappings = TS.domain.properties.DomainProperty.prototype.mapping;

/**
 * @class TS.domain.properties.NavBlockProperty
 * @extends TS.domain.properties.DomainProperty
 */
TS.domain.properties.NavBlockProperty = new Class(
/** @lends TS.domain.properties.NavBlockProperty# */
{
    Extends: TS.domain.properties.DomainProperty,

	mapping: $.extend(baseMappings, {
		suppress: baseMappings.suppress.concat(['Title', 'Roots'])
	}),

    initialize: function (domain, config) {
        var me = this;
        me.parent(domain, config);
    },

    /**
     * Returns the root with the specified ID.
     * @param rootId {String}
     * @returns {Object} The root or <code>null</code> if there's no root with specified ID.
     */
    getRoot: function(rootId){
        var me = this,
            root = null;

        $.each(me.roots, function(i, r){
            if (r.id == rootId){
                root = r;
                return false;
            }
        });

        return root;
    },

    /**
     * Returns a section for the specified root ID and section ID.
     * @param rootId {String}
     * @param sectionId {String}
     * @returns {Object} The section or <code>null</code> if there's no root or section with specified IDs.
     */
    getSection: function(rootId, sectionId){
        var me = this,
            root,
            section = null;

        root = me.getRoot(rootId);
        if (!root)
            return null;

        $.each(root.sections, function(i, s){
            if (s.id == sectionId){
                section = s;
                return false;
            }
        });

        return section;
    }
});

TS.ObjectFactory.map('NavBlockProperty', TS.domain.properties.NavBlockProperty);